export const LOGIN_MENU_ID = '@members_login';
export const MEMBERS_MENU_ID = '@members_menu';
export const APP_WIDGET_LOGIN_MENU_ID = '@members-login-bar';
export const APP_WIDGET_MEMBERS_MENU_ID = '@members-menu';
